export default __webpack_public_path__ + "static/media/veg_icon.d26e5092.svg";